<template>
    <v-app>
        <v-content>
            <v-container class="fill-height">
                <v-row align="center" justify="center">
                    <v-col cols="6" md="4">
                        <p class="text-center">
                            Memuat
                        </p>

                        <v-progress-linear indeterminate color="primary"></v-progress-linear>

                        <div v-if="homeShow" class="text-center mt-4">
                            <v-btn :to="{ name: 'home' }" exact icon color="primary">
                                <v-icon>
                                    mdi-home
                                </v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
export default {
    data() {
        return {
            homeTimeout: null,
            homeShow: false
        }
    },

    created() {
        this.homeTimeout = setTimeout(() => this.homeShow = true, 1000)
    },

    destroyed() {
        clearTimeout(this.homeTimeout)
    }
}
</script>
